import React, { useEffect, useState, useRef } from 'react';
import { connect } from "react-redux";
import AlertBar from '../../Stakeholder/AlertBar';
import axios from "axios";
import moment from "moment";
import { Trans } from 'react-i18next';
import { checkCredentials } from '../../../Helpers/checkCredentials.js';
import i18n from '../../../i18n';
import { P3 } from '../../Common/DesignSystem/Text.jsx';
import colours from '../../Common/DesignSystem/Colours.jsx';
import { Input, DropdownItem } from '../../Common/DesignSystem/Input.jsx';
import Button from '../../Common/DesignSystem/Button.jsx';
import { GridContainer, GridItem } from '../../Common/DesignSystem/Grid.jsx';
import { useLazyQuery, useQuery } from '@apollo/client';

import ReactToPrint from 'react-to-print';
import { exportToast, generateDashboardReport } from '../../../Helpers/generateCsv';
import _ from 'lodash';
import Navbar from '../../Navbar';
import ModalRoutes from '../ModalRoutes';
import { GET_PENDING_BOOKINGS, } from '../../../GraphQL/Queries/bookings';
import { GET_NEW_DASHBOARD } from '../../../GraphQL/Queries/dashboard';


import { BookingsCard, VehiclesCard } from "./Dashboard"

const StakeholderDashboard = (props) => {
    const cards_container_ref = useRef(null);
    const [dashboardData, setDashboardData] = useState(null);
    const [loadingDashboard, setLoadingDashboard] = useState(true);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [divisionOptions, setDivisionOptions] = useState(
        [...new Set(props?.userSession?.user.profile_access?.active_sh_vmh_access.map(a => {
            return {
                value: a.stakeholder.SH_ID,
                option: a.stakeholder.Company + ' ' + a.stakeholder.Division,
                stakeholder: a.stakeholder
            }
        }).filter((value, index, self) =>
            index === self.findIndex((t) => (
                t.value === value.value && t.option === value.option
            ))
        ))]
    )
    const [selectedDivision, setSelectedDivision] = useState(divisionOptions[0].value);
    const [reportStartDate, setReportStartDate] = useState(moment().startOf('day').subtract(30, 'days').format('YYYY-MM-DD'));
    const [reportStartDateLabel, setReportStartDateLabel] = useState('Last 30 Days');

    const [pendingData, { data, loading, called }] = useLazyQuery(GET_PENDING_BOOKINGS, {
        variables: {
            "stakeholderAndVehicleCenterInputs": props.userSession?.user?.profile_access?.active_sh_access,
        },
        errorPolicy: 'all'
    });

    function openCovid() {
        var base_url = (props.match.url).split('/')[1]
        props.history.push("/" + base_url + '/covid-update');
    }

    function openReleaseNotesModal() {
        props.history.push(`${props.match.url}/release-notes`);
    }

    useEffect(() => {
        const shouldShowReleaseNotes = props.userSession.user.latest_release_note;

        if (shouldShowReleaseNotes) {
            openReleaseNotesModal();
        }
    }, []);

    function updateDivision(e) {
        setSelectedDivision(parseInt(e.target.value));
    }

    const startExport = () => {
        exportToast({
            type: 'dashboard',
            data: {
                dash_data: dashboardData, time_period: reportStartDateLabel, sh: divisionOptions.find((a) => {
                    return a.value === selectedDivision
                })?.option
            },
            action: generateDashboardReport,
        });
    }


    useEffect(() => {
        document.title = "Dashboard - FleetXPress"
        const resize = () => {
            setWindowWidth(window.innerWidth);
        }

        pendingData().then((res) => {
            const pending_bookings = res?.data?.getPendingBookings?.bookings || [];

            if (Object.keys(props.data.dashboard_info).length === 0) {
                axios.get('/ajax/dashboard/data')
                    .then(function (response) {
                        checkCredentials(response);
                        let dash_data = {
                            // booking_request_list: response?.data.bookings.pending,
                            booking_request_list: pending_bookings,
                            user_request_list: response?.data.invites,
                            vehicle_reminder_list: response?.data.reminders.active,
                            damaged_vehicle_list: response?.data.damaged_vehicles,
                            outstanding_media_list: response?.data.outstanding_media
                        }
                        props.dispatch({ type: "SET_ALERTBAR_LISTS", payload: dash_data });
                        setLoadingDashboard(false);
                    })
                    .catch(function (error) {
                        if (error.response?.status == 401) {
                            showStatusMsg(error.response?.data.error);
                        } else if (error.response?.status == 422) {
                            var error_message = "";

                            $.each(error.response?.data.errors, function (index, element) {
                                error_message += element + '<br />';
                            });

                            showStatusMsg(error_message);
                        } else {
                            showStatusMsg("Requested information not found");
                        }
                    })
            } else {
                axios.get('/ajax/dashboard/data')
                    .then(function (response) {
                        checkCredentials(response);
                        let dash_data = {
                            // booking_request_list: response?.data.bookings.pending,
                            booking_request_list: pending_bookings,
                            user_request_list: response?.data.invites,
                            vehicle_reminder_list: response?.data.reminders.active,
                            damaged_vehicle_list: response?.data.damaged_vehicles,
                            outstanding_media_list: response?.data.outstanding_media
                        }
                        props.dispatch({ type: "SET_ALERTBAR_LISTS", payload: dash_data });
                        setLoadingDashboard(false);
                    })
                    .catch(function (error) {
                        if (error.response?.status == 401) {
                            showStatusMsg(error.response?.data.error);
                        } else if (error.response?.status == 422) {
                            var error_message = "";

                            $.each(error.response?.data.errors, function (index, element) {
                                error_message += element + '<br />';
                            });

                            showStatusMsg(error_message);
                        } else {
                            showStatusMsg("Requested information not found");
                        }
                    })
            }

        });
        window.addEventListener("resize", resize);

        return () => {
            window.removeEventListener("resize", resize);
        }
    }, [])

    const renderCards = (props) => {
        const { loading, data } = useQuery(GET_NEW_DASHBOARD, {
            variables: {
                months: 12,
                annualStartDate: moment().subtract(1, 'year').format('YYYY-MM-DD'),
                reportStartDate: reportStartDate,
                reportEndDate: moment().format('YYYY-MM-DD'),
                stakeholderId: selectedDivision,
                vehicleCenterIds: props.userSession ? [...new Set(props.userSession?.user?.profile_access?.active_sh_vmh_access?.map(a => {
                    if (a.SH_ID == selectedDivision) {
                        return a.VMH_ID;
                    }
                }).filter(i => i))] : []
            }
        });


        let bookingData = null;
        let vehicleData = null;

        if (data) {
            const { bookingInsight, monthlyBookings, vehiclesInsight, monthlyVehiclesUtilizations, topUtilizationVehicles } = data?.newDashboard;
            const { annualBookingsInsight, annualVehiclesInsight } = data?.annualDashboardData;
            bookingData = {
                bookingsInsights: bookingInsight,
                annualBookingInsights: annualBookingsInsight,
                monthlyBookings: monthlyBookings?.map((month) => {
                    return { name: month.monthName.substr(0, 3), value: month.total };
                }),
            }
            vehicleData = {
                vehiclesInsights: vehiclesInsight,
                annualVehicleInsights: annualVehiclesInsight,
                monthlyVehiclesUtilizations: monthlyVehiclesUtilizations?.map((month) => {
                    return { name: month.monthName.substr(0, 3), value: Math.round(month.utilization * 100) };
                }),
                highestUtilizationVehicles: topUtilizationVehicles.highest,
                lowestUtilizationVehicles: topUtilizationVehicles.lowest
            }
        }



        if (!_.isEqual({ bookingData, vehicleData }, dashboardData))
            setDashboardData({ bookingData, vehicleData });

        return (
            <>
                <GridItem xs={windowWidth > 768 ? 6 : 12}>
                    <BookingsCard
                        windowWidth={windowWidth}
                        dashboardData={bookingData}
                        isLoading={loading}
                        {...props}
                    />
                </GridItem>
                <GridItem xs={windowWidth > 768 ? 6 : 12} style={{ display: 'flex' }}>
                    <VehiclesCard
                        windowWidth={windowWidth}
                        dashboardData={vehicleData}
                        isLoading={loading}
                        {...props}
                    />
                </GridItem>
            </>
        )
    }

    if (props.userSession) {
        return (
            <div className="bkg-white-dark" style={{ height: '100vh' }}>
                <Navbar history={props.history} match={props.match} location={props.location} />
                <AlertBar page="dashboard" match={props.match} history={props.history} loading={loadingDashboard} pendingBookings={data} />
                <div className="sh-dashboard-container fixed-navbar-page fixed-alertbar-page" ref={cards_container_ref}>
                    {/* <div className="covid-19-banner">
                        <div className="covid-text">
                            <Trans>Integrated Automotive is keeping you safe with our enhanced Covid-19 Processes. For details,</Trans> <a onClick={openCovid} style={{ cursor: 'pointer' }}><Trans>click here</Trans>.</a>
                        </div>
                    </div> */}
                    <div className="sh-title-section">
                        <h3 className="float-left mt-8">Dashboard</h3>
                        <div className="float-right">
                            <Input
                                simple_dropdown
                                options={divisionOptions}
                                value={divisionOptions.find((a) => {
                                    return a.value === selectedDivision
                                })?.value}
                                onChange={updateDivision}
                                containerStyle={{ maxWidth: '250px' }}
                            />
                        </div>
                    </div>
                    <div style={{ width: '100%', flexGrow: 1, background: colours.primary.grey05, padding: '16px', display: 'flex', flex: 1, zIndex: 3, flexDirection: 'column' }}>
                        <div style={{ display: 'flex', flexDirection: 'row', margin: '8px 16px', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                                <P3 style={{ color: colours.primary.grey02, lineHeight: '58px', marginRight: '8px' }}>
                                    Show
                                </P3>
                                <Input
                                    dropdown
                                    inputclass="rounded-primary"
                                    name="start_date"
                                    onChange={(e) => {
                                        setReportStartDateLabel(e.currentTarget.id);
                                        setReportStartDate(e.currentTarget.dataset.id)
                                    }}
                                    value={reportStartDate}
                                    dropdownLabel={reportStartDateLabel}
                                    // leading_ic="Calendar"
                                >
                                    <DropdownItem label="Today" value={moment().startOf('day').format('YYYY-MM-DD')} />
                                    <DropdownItem label="Yesterday" value={moment().startOf('day').subtract(1, 'day').format('YYYY-MM-DD')} />
                                    <DropdownItem label="Last 7 days" value={moment().startOf('day').subtract(7, 'days').format('YYYY-MM-DD')} />
                                    {/* <DropdownItem label="Month-to-date" value={moment().startOf('month').format('YYYY-MM-DD')}/> */}
                                    <DropdownItem label="Last 30 days" value={moment().startOf('day').subtract(30, 'days').format('YYYY-MM-DD')} />
                                    <DropdownItem label="Last 90 days" value={moment().startOf('day').subtract(90, 'days').format('YYYY-MM-DD')} />
                                    <DropdownItem label="Year-to-date" value={moment().startOf('year').format('YYYY-MM-DD')} />
                                    <DropdownItem label="Last 12 months" value={moment().startOf('day').subtract(1, 'year').format('YYYY-MM-DD')} />
                                </Input>
                            </div>
                            <div className="print-export-buttons" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <ReactToPrint
                                    trigger={() => {
                                        return <Button label="Print Report" secondary leading_ic='Print' style={{ marginRight: 16 }} />;
                                    }}
                                    content={() => cards_container_ref.current}
                                />
                                <Button label="Export" secondary leading_ic='Export' onClick={() => { startExport() }} />
                            </div>
                        </div>
                        <div id="cards-container">
                            <GridContainer spacing={windowWidth > 768 ? 3 : 0}>
                                {renderCards(props)}
                            </GridContainer>
                        </div>
                    </div>
                </div>
                <ModalRoutes match={props.match} history={props.history} />
            </div>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data,
    stakeholder: store.stakeholder
})

export default connect(mapStateToProps)(StakeholderDashboard)